import React, { useEffect, useState } from "react";
import api, { errMsg, publicImg } from "../../core/api";
import { useApp } from "../../core/AppContext";
import FormFields from "../../components/FormFields";
import ImageField from "../../components/ImageField";

const FIELDS = [
  { name: "orgName", label: "نام اداره", required: true },
  { name: "unitName", label: "نام واحد", required: true },
  { name: "managerName", label: "نام و نام خانوادگی مسئول واحد" },
  { name: "mobile", label: "شماره موبایل", type: "mobile", placeholder: "09xxxxxxxxx" },
];

export default function OrgInfo() {
  const { toast } = useApp();
  const [form, setForm] = useState(null);
  const [org, setOrg] = useState(null);
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);
  const [busy, setBusy] = useState("");

  const apply = (o) => { setOrg(o); setForm({ orgName: o.orgName || "", unitName: o.unitName || "", managerName: o.managerName || "", mobile: o.mobile || "" }); };
  useEffect(() => { api.get("/org").then((r) => apply(r.data.org)).catch((e) => setErr(errMsg(e))); }, []);

  const save = async () => {
    setSaving(true); setErr("");
    try { const { data } = await api.put("/org", form); apply(data.org); toast("اطلاعات اداره ذخیره شد"); }
    catch (e) { setErr(errMsg(e)); } finally { setSaving(false); }
  };

  const upload = (field, outW, outH) => async (blob) => {
    setBusy(field);
    try {
      const fd = new FormData();
      fd.append("file", blob, `${field}.png`);
      const { data } = await api.post(`/org/image/${field}`, fd);
      setOrg(data.org); toast("تصویر ذخیره شد");
    } catch (e) { toast(errMsg(e), "err"); } finally { setBusy(""); }
  };
  const remove = async (field) => {
    setBusy(field);
    try { const { data } = await api.delete(`/org/image/${field}`); setOrg(data.org); } catch (e) { toast(errMsg(e), "err"); } finally { setBusy(""); }
  };

  if (!form) return <div className="empty"><div className="spinner" style={{ margin: "0 auto" }} /></div>;
  const img = (f) => publicImg("org", org[f]);

  return (
    <>
      <div className="page-head"><div><h2>اطلاعات اداره</h2><p>اطلاعات اداره و واحد که در گزارش‌ها و مکاتبات استفاده می‌شود</p></div></div>
      <div className="card card-pad" style={{ maxWidth: 820 }}>
        {err && <div className="alert err">{err}</div>}
        <FormFields fields={FIELDS} form={form} setForm={setForm} />
        <button className="btn" onClick={save} disabled={saving}>{saving ? "در حال ذخیره..." : "ذخیره اطلاعات"}</button>
      </div>

      <div className="card card-pad" style={{ maxWidth: 820, marginTop: 14 }}>
        <div className="grid2">
          <ImageField label="لوگوی اداره" preview={img("orgLogo")} aspect={1} busy={busy === "orgLogo"} onPick={upload("orgLogo")} onRemove={() => remove("orgLogo")} onError={(m) => toast(m, "err")} />
          <ImageField label="لوگوی واحد" preview={img("unitLogo")} aspect={1} busy={busy === "unitLogo"} onPick={upload("unitLogo")} onRemove={() => remove("unitLogo")} onError={(m) => toast(m, "err")} />
          <ImageField label="امضای مسئول واحد" preview={img("managerSignature")} aspect={2} outW={600} outH={300} busy={busy === "managerSignature"}
            onPick={upload("managerSignature")} onRemove={() => remove("managerSignature")} onError={(m) => toast(m, "err")} hint="ترجیحاً با پس‌زمینه‌ی سفید یا شفاف" />
        </div>
      </div>
    </>
  );
}
